import type { PreviewContact, ValidationError } from '../types/import';
import { parseAndValidateDate } from './dateUtils';

export function validateContacts(contacts: PreviewContact[]): ValidationError[] {
  const errors: ValidationError[] = [];
  const rowErrors = new Map<number, ValidationError>();

  contacts.forEach((contact, index) => {
    const row = index + 1;
    
    // Required fields
    if (!contact.first_name?.trim()) {
      if (!rowErrors.has(row)) {
        rowErrors.set(row, {
          row,
          field: 'first_name',
          message: 'First name is required'
        });
      }
      return;
    }

    if (!contact.last_name?.trim()) {
      if (!rowErrors.has(row)) {
        rowErrors.set(row, {
          row,
          field: 'last_name',
          message: 'Last name is required'
        });
      }
      return;
    }

    // At least one contact method required
    if (!contact.personal_email && !contact.work_email && !contact.phone_number && !contact.work_phone) {
      if (!rowErrors.has(row)) {
        rowErrors.set(row, {
          row,
          field: 'contact',
          message: 'At least one contact method (email or phone) is required'
        });
      }
      return;
    }

    // Email format validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (contact.personal_email && !emailRegex.test(contact.personal_email)) {
      if (!rowErrors.has(row)) {
        rowErrors.set(row, {
          row,
          field: 'personal_email',
          message: 'Invalid personal email format'
        });
      }
      return;
    }
    if (contact.work_email && !emailRegex.test(contact.work_email)) {
      if (!rowErrors.has(row)) {
        rowErrors.set(row, {
          row,
          field: 'work_email',
          message: 'Invalid work email format'
        });
      }
      return;
    }

    // Phone format validation (basic)
    const phoneRegex = /^[\d\s\-\+\(\)]+$/;
    if (contact.phone_number && !phoneRegex.test(contact.phone_number)) {
      if (!rowErrors.has(row)) {
        rowErrors.set(row, {
          row,
          field: 'phone_number',
          message: 'Invalid phone number format'
        });
      }
      return;
    }
    if (contact.work_phone && !phoneRegex.test(contact.work_phone)) {
      if (!rowErrors.has(row)) {
        rowErrors.set(row, {
          row,
          field: 'work_phone',
          message: 'Invalid work phone format'
        });
      }
      return;
    }

    // Date validation
    if (contact.birthday && typeof contact.birthday === 'string' && !parseAndValidateDate(contact.birthday)) {
      if (!rowErrors.has(row)) {
        rowErrors.set(row, {
          row,
          field: 'birthday',
          message: 'Invalid date format for birthday'
        });
      }
      return;
    }
  });

  return Array.from(rowErrors.values());
}